"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatSortDescriptors;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _SortDirection = _interopRequireDefault(require("./SortDirection"));

/*
  formatSortDescriptors([
    { name: "json(data.name)", direction: "ascending" }, {
    { name: "thing", direction: "descending" }
  ]);
  // => "+json(data.name),-thing"
*/
function formatSortDescriptors() {
  var descriptors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return descriptors.reduce(function (sortKeys, descriptor) {
    var direction = descriptor.direction,
        name = descriptor.name;

    switch (direction) {
      case _SortDirection.default.ASCENDING:
        return [].concat((0, _toConsumableArray2.default)(sortKeys), ["+".concat(name)]);

      case _SortDirection.default.DESCENDING:
        return [].concat((0, _toConsumableArray2.default)(sortKeys), ["-".concat(name)]);

      default:
        return [].concat((0, _toConsumableArray2.default)(sortKeys), [name]);
    }
  }, []).join(',');
}